import component from './PhSparkle.vue_vue_type_script_lang.vue.js';
export { default } from './PhSparkle.vue_vue_type_script_lang.vue.js';
import { render } from './PhSparkle.vue_vue_type_template_id_5273a17d_lang.vue.js';

component.render = render;
